import { Button, DialogContent, Dialog, DialogTitle } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import MembersCard from "../components/Canvas";
import { WarningIcon } from "../svg/WarningIcon";
import UseInfoMain from "../components/UseInfoMain";
import UseInfoPassport from "../components/UseInfoPassport";
import UseInfoOthers from "../components/UseInfoOthers";
import PictureUpload from "../components/PictureUpload";
import UseInfoEmail from "../components/UseInfoEmail";
import UserInfoEmergency from "../components/UserInfoEmergency";
import { Link } from 'react-router-dom';
import HeaqderNav from "../components/HeaqderNav";
import { imgPath, gasPath, TokenContext, restPath, nearExpiry, prefix } from '../App';

const Edit = () => {
  const token = useContext(TokenContext);
  const storedData = sessionStorage.getItem("jacUserCore");
  const [userInfo, setUserInfo] = useState([]);
  const [currentEmail, setCurrentEmail] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [validateStatus, setValidateStatus] = useState({
    email: { valid: true, message: '' },
    firstName: { valid: true, message: '' },
    middleName: { valid: true, message: '' },
    familyName: { valid: true, message: '' },
    firstNameEn: { valid: true, message: '' },
    middleNameEn: { valid: true, message: '' },
    familyNameEn: { valid: true, message: '' },
    passportNo: { valid: true, message: '' },
    passportExpiry: { valid: true, message: '' },
    phone: { valid: true, message: '' },
    address: { valid: true, message: '' },
    job: { valid: true, message: '' },
    emergencyContact: { valid: true, message: '' },
    emergencyPerson: { valid: true, message: '' },
  });
  const [verifying, setVerifying] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const requiredFields = [
    'email',
    'firstName',
    'familyName',
    'firstNameEn',
    'familyNameEn',
    'passportNo',
    'birthday',
    'passportExpiry',
    'img'
  ];
  console.log(keyboardOpen)
  useEffect(() => {
    if (storedData && currentEmail === null) {
      setUserInfo(JSON.parse(storedData));
      setCurrentEmail(JSON.parse(storedData).email)
    }
  }, [])

  // useEffect(() => {
  //   if (detail === false && open) {
  //     setOpen(false);
  //   }
  // }, [detail, isEdit, open]);



  useEffect(() => {

    if (!userInfo?.id) return;
    if (userInfo?.img) return;
    const fetchData = async () => {

      try {
        const res = await fetch(`${restPath}/wp-json/base64/v1/getImgData?id=${userInfo?.id}`);
        const data = await res.json();
        if (data.status === "success") {
          const base64 = data?.imgData?.base64 || null;

          const updatedUser = { ...userInfo, img: base64 };
          sessionStorage.setItem("jacUserCore", JSON.stringify(updatedUser));
          setUserInfo(prev => ({ ...prev, img: base64 }));
        } else {
          console.error("取得失敗:", data.message);
          return null;
        }

      } catch (err) {
        console.error("画像取得失敗:", err);
      }
    };

    fetchData();


  }, [userInfo])

  const updateUserInfoHandler = () => {
    setVerifying(true);
    console.log(`start`)
    //前後の空白削除
    const updateData = Object.fromEntries(
      Object.entries(userInfo).map(([key, value]) => {
        if (typeof value === 'string') {
          return [key, value.trim()];
        }
        return [key, value];
      })
    );

    if (userInfo.email === currentEmail) {
      delete updateData.email;
    }

    console.log(updateData)

    Promise.all([
      fetch(`${restPath}/wp-json/${prefix}base64/v1/registerImgData`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: userInfo?.id,
          imgData: userInfo?.img,
        })
      }),
      fetch(gasPath, {
        method: "POST",
        body: JSON.stringify({
          ...updateData,
          jacStatus: `update`,
          token: token
        }),
        headers: {
          "Content-Type": "text/plain"
        }
      })
    ])
      .then(async ([wpRes, gaRes]) => {
        const wpJson = await wpRes.json();
        const gaText = await gaRes.text();
        const gaJson = JSON.parse(gaText);

        if (gaJson.status === 'success' && wpJson.status === 'success') {
          sessionStorage.setItem("jacUserCore", JSON.stringify(userInfo));
          setIsSuccess(true);
        } else {
          setIsSuccess(false);
        }
      })
      .catch(err => {
        console.error("Error in fetch:", err);
        setIsSuccess(false);
      })
      .finally(() => {
        // 成功・失敗に関わらず必ず実行
        setVerifying(false);
        setIsEdit(false);
        setOpen(true);
      });
  }

  const Sticky = () => {
    if (userInfo.membership === 'invalid') {
      const classes = userInfo.membership === `invalid` ? `sticky red` : `sticky red bottom`
      return <p className={classes}>
        <WarningIcon></WarningIcon>
        有効期限が切れています
        <Button
          component={Link}
          to="/payment/"
          style={{ background: `var(--yellow)`, border: `none`, color: `#000`, height: `40px`, width: `100px`, borderRadius: `4px`, fontWeight: `bold` }}
        >
          更新する
        </Button>
      </p>
    }
    else if (nearExpiry(userInfo.expiry) && (userInfo.membership === `supporting` || userInfo.membership === `end_paypal_subscription`)) {
      return <p className={`sticky`}>
        <WarningIcon></WarningIcon>
        有効期限が近づいています
        <Button
          component={Link}
          to="/payment/"
          style={{ background: `var(--red)`, border: `none`, color: `#fff`, height: `40px`, width: `100px`, borderRadius: `4px`, fontWeight: `bold` }}
        >
          更新する
        </Button>
      </p>

    }
  }

  const BackImage = () => {
    if (userInfo.membership === 'invalid') {
      return <img src={`${imgPath}/images/expired.svg`} className="bg-img" alt="" />
    }
    else if (userInfo.membership === 'temporary') {
      return <img src={`${imgPath}/images/temporary.svg`} className="bg-img" alt="" />
    }
  }

  useEffect(() => {
    const isFormReady = () => {
      const isAllValid = Object.values(validateStatus).every(v => v.valid);

      // 通常の必須項目チェック
      const isUserInfoComplete = requiredFields.every(key => {
        const val = userInfo[key];
        return val !== undefined && val !== null && String(val).trim() !== '';
      });

      // 電話番号は特別扱い：どちらか片方があればOK
      const phonePhDigits = userInfo.phonePh?.replace(/[^\d]/g, '') ?? '';
      const phoneJaDigits = userInfo.phoneJa?.replace(/[^\d]/g, '') ?? '';
      const isPhoneComplete = phonePhDigits.length > 0 || phoneJaDigits.length > 0;

      return isAllValid && isUserInfoComplete && isPhoneComplete;
    };

    setIsUpdated(isFormReady());
  }, [userInfo, validateStatus]);
  return <>
    <HeaqderNav></HeaqderNav>
    <ul className="breadcrumb">
      <li>
        <Link to="/user-info">会員情報</Link>
      </li>
      <li>詳細</li>

    </ul>
    <BackImage></BackImage>
    {open && <UpdateMsg setOpen={setOpen} userInfo={userInfo} isSuccess={isSuccess}></UpdateMsg>}

    {isEdit && <p style={{ textAlign: `right`, margin: `16px auto`, fontSize: `12px` }}><span style={{ color: `var(--red)` }}>※</span>は必須です。</p>}
    <dl className="dl">
      <dt>有効期限</dt>
      <dd style={
        userInfo.membership === `invalid`
          ? { opacity: 0.3 }
          : {
            color: nearExpiry(userInfo.expiry) ? 'var(--red)' : 'inherit',
            fontWeight: nearExpiry(userInfo.expiry) ? 'bold' : 'normal',
          }
      }>
        {userInfo.expiry}
      </dd>
    </dl>
    {isEdit ? <PictureUpload setUserInfo={setUserInfo} userInfo={userInfo}></PictureUpload> :
      <p style={{ margin: `16px auto` }}>
        <img src={userInfo.membership !== 'invalid' ? userInfo.img : `${imgPath}/images/dummy.jpg`} alt="" width={100} height={110} />
      </p>
    }
    <dl className="dl" style={{ marginBottom: `54px` }}>
      <dt>会員番号</dt>
      <dd>
        {userInfo.id}
      </dd>
      <UseInfoEmail userInfo={userInfo} isEdit={isEdit} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoEmail>
      <UseInfoMain userInfo={userInfo} isEdit={isEdit} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoMain>
      <dt>誕生日{isEdit && <span>※</span>}</dt>
      <dd>
        {userInfo.birthday}
      </dd>
    </dl>

    <h2>旅券情報</h2>
    <UseInfoPassport userInfo={userInfo} isEdit={isEdit} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoPassport>
    <h2>その他</h2>
    <UseInfoOthers userInfo={userInfo} isEdit={isEdit} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus}></UseInfoOthers>
    <h2>緊急連絡先</h2>
    <div style={keyboardOpen && isEdit ? { paddingBottom: `300px` } : { paddinBottom: 0 }}>
      <UserInfoEmergency userInfo={userInfo} isEdit={isEdit} setUserInfo={setUserInfo} validateStatus={validateStatus} setValidateStatus={setValidateStatus} setKeyboardOpen={setKeyboardOpen}></UserInfoEmergency>
    </div>

    {isEdit ? <p style={{ textAlign: `center`, marginTop: `12px`, display: `flex`, justifyContent: `center`, gap: `16px` }}>
      <Button
        onClick={() => setIsEdit(false)}
        style={{ background: `var(--border)`, color: `#fff`, fontSize: `18px` }}
        sx={{ width: "150px" }}
      >取り消し</Button>
      <Button
        onClick={updateUserInfoHandler}
        style={{ background: `var(--red)`, color: `#fff`, fontSize: `18px` }}
        sx={{ width: "150px" }}
        disabled={!isUpdated}
      >更新する</Button>

    </p>
      :
      <p style={{ textAlign: `center`, marginTop: `12px`, display: `grid`, justifyContent: `center`, gap: `16px` }}>
        <Button
          onClick={() => setIsEdit(true)}
          style={{ background: `var(--blue)`, color: `#fff`, fontSize: `18px` }}
          sx={{ width: "250px" }}
        >修正する</Button>
        <Button
          component={Link} to="/user-info"
          style={{ background: `var(--border)`, color: `#fff`, fontSize: `18px` }}
          sx={{ width: "250px" }}
        >戻る</Button>
      </p>
    }

    <Sticky></Sticky>
    {verifying && <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div>}

  </>

}
export default Edit;

const UpdateMsg = ({ userInfo, isSuccess }) => {

  return <div className={isSuccess ? `msg-success` : `msg-failed`}>
    <p className="title">{userInfo?.id}のユーザー情報{isSuccess ? `を更新しました` : `更新に失敗しました`}</p>
    {isSuccess ? <p>ユーザー情報の更新に成功しました。</p> : <p>ユーザー情報の更新に失敗しました。お手数ですが、お時間をおいて再度お試しください。それでもうまく行かない場合は、<a href="/contact/" target="_blank">日本人事務局</a>までお問い合わせください。</p>}
  </div>
}
